import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  page: {
    display: 'flex',
    minHeight: '100vh',
    flexDirection: { xs: 'column', md: 'row' }
  } satisfies SxProps<Theme>,
  brandPanel: {
    flex: 1,
    p: { xs: '32px', md: '56px' },
    background: 'linear-gradient(160deg, var(--white) 0%, var(--blue-50) 55%, var(--blue-100) 100%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  } satisfies SxProps<Theme>,
  logo: {
    height: '48px',
    alignSelf: 'flex-start',
    mb: '32px'
  } satisfies SxProps<Theme>,
  brandHeading: {
    fontWeight: 700,
    mb: '12px'
  } satisfies SxProps<Theme>,
  brandCopy: {
    maxWidth: '420px'
  } satisfies SxProps<Theme>,
  formPanel: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    p: { xs: '24px', md: '56px' },
    backgroundColor: 'var(--white)',
    borderLeft: { md: '1px solid var(--border)' }
  } satisfies SxProps<Theme>,
  formCard: {
    width: '100%',
    maxWidth: '560px'
  } satisfies SxProps<Theme>
}
